import styled, { css } from 'styled-components';

import Input from 'components/ui/Input';
import Button, { ConfirmButton } from 'components/ui/Button';

import { colours } from 'themes/default';

export const StyledInput = styled(Input)`
  margin-left: 8px;
  width: 60px;
  ${({ disabled }) =>
    !disabled &&
    css`
      border-width: 1px;
      border-color: ${colours.Shades.BlueShade40};
    `}
`;

export const StyledButton = styled(Button)`
  margin: 0 0 0 16px;
`;

export const StyledConfirmButton = styled(ConfirmButton)`
  margin: 0 0 0 16px;
`;

export const StyledForm = styled.form`
  display: flex;
  align-items: center;
`;

export const StyledErrorMessage = styled.p`
  margin: 0;
  width: 100%;
  color: ${colours.Messaging.ErrorRed};
`;
